import React, { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { getSvipPurchaseOrders } from '../../api'
import { formatAmount, formatDateTime, getPaymentText, getShopName, RECORD_PAGE_SIZE } from './record-utils'
import MemberRecordTable from './record-table'

interface Props {
    memberId: number
}

const itemTypeMap: { [key: number]: string } = {
    0: '月卡',
    1: '季卡',
    2: '年卡',
}

const PayRecord: React.FC<Props> = props => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(RECORD_PAGE_SIZE)
    const req = useRequest(() => getSvipPurchaseOrders({ member_id: props.memberId, page, limit: pageSize }), {
        refreshDeps: [props.memberId, page, pageSize],
        onError: e => $msg('error', e.message || '获取付费记录失败'),
    })
    const columns: ColumnsType<any> = [
        { title: '时间', dataIndex: 'create_time', width: 170, render: formatDateTime },
        { title: '订单号', dataIndex: 'order_no', width: 220, render: value => value || '-' },
        { title: '购买类型', dataIndex: 'item_type', width: 120, render: value => itemTypeMap[value] || '-' },
        { title: '店铺', dataIndex: 'shop', width: 160, render: getShopName },
        { title: '金额', dataIndex: 'payment_amount', width: 112, render: formatAmount },
        {
            title: '支付方式',
            width: 140,
            render: (_value, record) =>
                getPaymentText(record.payment || record.payments || record.payment_type_text || record.payment_type),
        },
    ]

    return (
        <MemberRecordTable
            rowKey={(record, index) => record.order_no || index}
            loading={req.loading}
            columns={columns}
            dataSource={req.data?.records || []}
            page={page}
            pageSize={pageSize}
            pagination={req.data?.pagination}
            onPageChange={setPage}
            onPageSizeChange={(nextPage, nextSize) => {
                setPage(nextPage)
                setPageSize(nextSize)
            }}
        />
    )
}

export default PayRecord
